import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface BulkUploadPdfPagePreview {
  isSelected: boolean;
  imageUrl?: string;
  width?: number;
  height?: number;
}

@Component({
  selector: 'app-bulk-upload-pdf-preview-selector',
  templateUrl: './bulk-upload-pdf-preview-selector.component.html',
  styleUrls: ['./bulk-upload-pdf-preview-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadPdfPreviewSelectorComponent {
  @Input() pageItems: BulkUploadPdfPagePreview[] = [];
  @Output() pageSelectionChange = new EventEmitter<{ index: number; isSelected: boolean }>();

  toggleItemSelection(index: number) {
    const nextSelected = !this.pageItems[index].isSelected;
    this.pageSelectionChange.emit({ index, isSelected: nextSelected });
  }

  trackByIndex(index: number): number {
    return index;
  }
}
